<div class="tabs-container" [ngClass]="spaced ? 'spaced' : ''">
  <div class="tabs-wrapper" [ngClass]="isLight ? 'light' : 'dark'">
    @for (tab of getVisibleTabs(); track tab; let i = $index) {
      <button
        class="tab-button"
        [ngClass]="{
          active: isTabSelected(tab),
          light: isLight,
          dark: !isLight
        }"
        [style.min-width]="getMinTabWidth()"
        (click)="onTabClick(tab)"
      >
        <div class="d-flex align-items-center gap-2 align-self-stretch">
          @if (tab.icon) {
            <img class="icons" [src]="getTabIcon(tab)" alt="" />
          }
          <span class="tab-text">{{ tab.needsTranslation !== false ? (tab.label | translate) : tab.label }}</span>
        </div>
        @if (showArrow && isTabSelected(tab)) {
          <div class="tab-arrow" [ngClass]="isLight ? 'light' : 'dark'">
            <app-icam-icon [iconName]="arrowIconName" [iconHeight]="arrowIconHeight" />
          </div>
        }
      </button>
    }
  </div>
</div>
